module.exports = __webpack_public_path__ + "static/media/bg-valley-mobile.7ead2c56.jpg";